module.exports = "fragment SendDelayFragment on SendDelay {\n  __typename\n  type\n  delayNumber\n  delayType\n  timeType\n  specificDate\n}\n"